const naturecontext = Array(1000).fill("Decorative wallpapers enhance interiors with charm and elegance, transforming plain walls into expressive features that reflect personality, style, and a refined sense of aesthetics.");

// Descriptions and context for nature wall data
export const naturedescriptions = Array.from({ length: 1000 }, () => `Decorative Series`);

// Base AWS S3 URL
const AWS_BASE_URL = "https://vizaura.s3.eu-north-1.amazonaws.com/WallCoverings/Decorative";

// Function to get image URL with fallback between .jpeg and .jpg
const getImageUrl = (imageNumber, useParentheses = false) => {
    const formatted = useParentheses ? `(${imageNumber})` : `${imageNumber}`;
    const jpegUrl = `${AWS_BASE_URL}/${formatted}.jpeg`;
    const jpgUrl = `${AWS_BASE_URL}/${formatted}.jpg`;

    // Return an object with both URLs for the component to handle
    return {
        jpeg: jpegUrl,
        jpg: jpgUrl
    };
};

// Seeded random generator (Mulberry32)
function mulberry32(seed) {
    return function () {
        let t = (seed += 0x6D2B79F5);
        t = Math.imul(t ^ (t >>> 15), t | 1);
        t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
        return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
    };
}

// Generate wall data: existing 545 (excluding 325) + new 43 images (1).jpg - (43).jpg
const generateWalldata = () => {
    const originalSet = Array.from({ length: 545 }, (_, index) => {
        const imgNum = index + 1;

        // Skip 325
        if (imgNum === 325) return null;

        const imageUrls = getImageUrl(imgNum, false);

        return {
            Img: imageUrls.jpeg,
            ImgJpg: imageUrls.jpg,
            ImgJpeg: imageUrls.jpeg,
            title: `#DC${String(imgNum).padStart(3, '0')}`,
            desc: naturedescriptions[index] || "Default description",
            context: naturecontext[index] || "Default context",
            btn: 'View Detail',
            number: imgNum, // keep number for easy filtering
        };
    }).filter(Boolean);

    const newSet = Array.from({ length: 43 }, (_, index) => {
        const imgNum = index + 1;
        const titleNum = 545 + imgNum;
        const imageUrls = getImageUrl(imgNum, true);

        return {
            Img: imageUrls.jpg,
            ImgJpg: imageUrls.jpg,
            ImgJpeg: imageUrls.jpeg,
            title: `#DC${String(titleNum).padStart(3, '0')}`,
            desc: naturedescriptions[545 + index] || "Default description",
            context: naturecontext[545 + index] || "Default context",
            btn: 'View Detail',
            number: titleNum,
        };
    });

    return [...originalSet, ...newSet];
};

// Shuffle but ensure 242, 347, 116 come first
function seededShuffleWithPriority(array, priority = [], seed = 123456) {
    const rng = mulberry32(seed);

    // Separate priority images
    const priorityItems = array.filter(item => priority.includes(item.number));
    const rest = array.filter(item => !priority.includes(item.number));

    // Shuffle rest deterministically
    const shuffled = [...rest];
    for (let i = shuffled.length - 1; i > 0; i--) {
        const j = Math.floor(rng() * (i + 1));
        [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
    }

    // Put priority items first in given order
    return [
        ...priority.map(num => priorityItems.find(item => item.number === num)).filter(Boolean),
        ...shuffled,
    ];
}

// Final export
export const walldata = seededShuffleWithPriority(generateWalldata(), [242, 347, 116], 42);
